import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UsersAdminPageComponent } from './components/users-admin-page/users-admin-page.component';
import { UsersPageComponent } from './components/users-page/users-page.component';

const routes: Routes = [
  { path: '', component: UsersPageComponent },
  { path: 'admin', component: UsersAdminPageComponent },
  { path: ':id', component: UserDetailsComponent },
  { path: 'admin/:id', component: UserDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule { }
